import axiosInstance from "../../api/axiosInstance";
import {
  FETCH_CUSTOMER_CONSOLIDATED_REPORT_REQUEST,
  FETCH_CUSTOMER_CONSOLIDATED_REPORT_SUCCESS,
  FETCH_CUSTOMER_CONSOLIDATED_REPORT_FAIL,
} from "../actionTypes";

export const fetchCustomerConsolidatedReport = (data, token) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CUSTOMER_CONSOLIDATED_REPORT_REQUEST });
    try {
      const response = await axiosInstance.post("/api/customer-report/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      dispatch({
        type: FETCH_CUSTOMER_CONSOLIDATED_REPORT_SUCCESS,
        payload: response.data,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const errorPayload = error.response?.data || { message: "Network Error" };
      dispatch({
        type: FETCH_CUSTOMER_CONSOLIDATED_REPORT_FAIL,
        payload: errorPayload,
      });
      return {
        success: false,
        error: errorPayload,
      };
    }
  };
};

